export default "__VITE_ASSET__SlTzxfco__"